import { ListingMagasin } from '@components/listing-magasin/models';
import { Block } from '@shared/models';

const regions = [
  'Nouvelle-Aquitaine',
  'Auvergne-Rhône-Alpes',
  'Hauts-de-France',
  'Île-de-France',
  'Occitanie',
  "Provence-Alpes-Côte d'Azur",
  'Bretagne',
  'Grand Est',
  'Pays de la Loire',
  'Normandie',
  'Bourgogne-Franche-Comté',
  'Centre-Val de Loire',
];

const depts = [
  'Bouches-du-Rhône',
  'Loire-Atlantique',
  'Nord',
  'Pas-de-Calais',
  'Charente-Maritime',
  'Gironde',
  'Ille-et-Vilaine',
  'Manche',
  'Rhône',
  'Saône-et-Loire',
  'Alpes-Maritimes',
  'Gard',
  'Haut-Rhin',
  'Haute-Garonne',
  'Haute-Savoie',
  'Isère',
  'Morbihan',
  'Moselle',
  'Pyrénées-Atlantiques',
  'Seine-Maritime',
  'Seine-et-Marne',
  'Val-de-Marne',
  'Corrèze',
  "Côtes-d'Armor",
  'Drôme',
  'Finistère',
  'Landes',
  'Loire',
  'Loiret',
  'Maine-et-Loire',
  'Paris',
  'Savoie',
  'Tarn',
  "Val-d'Oise",
  'Var',
  'Vendée',
  'Yvelines',
  'Aisne',
  'Ardennes',
  'Ardèche',
  'Aube',
  'Aveyron',
  'Bas-Rhin',
  'Calvados',
  'Cantal',
  'Charente',
  'Cher',
  "Côte-d'Or",
  'Deux-Sèvres',
  'Dordogne',
  'Doubs',
  'Essonne',
  'Eure',
  'Haute-Vienne',
  'Hautes-Alpes',
  'Hérault',
  'Indre',
  'Indre-et-Loire',
  'Loir-et-Cher',
  'Lot',
  'Lot-et-Garonne',
  'Marne',
  'Mayenne',
  'Meurthe-et-Moselle',
  'Nièvre',
  'Oise',
  'Orne',
  'Sarthe',
  'Somme',
  'Tarn-et-Garonne',
  'Territoire de Belfort',
  'Vaucluse',
  'Vienne',
  'Yonne',
];

const pickRandomElement = <T>(array: T[]): T => array[Math.floor(Math.random() * array.length)]!;

export const listingMagasinMock = (type: 'region' | 'dept' | 'all'): Block<ListingMagasin> => ({
  type: 'listing-magasin',
  data: {
    type,
    area: type === 'region' ? pickRandomElement(regions) : pickRandomElement(depts),
    title: '666 magasins en Mordor',
  },
});
